<script setup lang="ts">
    import { IDocumentUnsolicitedQueueResponse } from '../../lib/Models/DocumentModel';
    import * as DateUtils from '../../lib/DateUtils';
    import * as UIEnums from '../../Enums/UiEnums';
    import SectionPanel from '../../components/SectionPanel.vue';
    import PrettyFileSize from '../../components/PrettyFileSize.vue';

    const props = withDefaults(defineProps<{
        item: IDocumentUnsolicitedQueueResponse
    }>(), {
    });

    const emit = defineEmits<{
        (e:"displayDocument", documentId: number): void
    }>();

    function displayDocument(documentId: number | undefined) {
        if (!documentId) {
            alert("DocumentId is missing.");
            return;
        }        
        emit("displayDocument",  documentId);
    }
</script>

<template>
    <SectionPanel class="background-isalus-primary-lightest" :key="props.item.documentId">
        <div class="container-fluid" style="cursor: pointer;" title="Click to view document" @click="displayDocument(props.item.documentId)">
            <div class="row RowHeader"> 
                <!--TODO: Display images based on document type - add a computed to the queueListResponseData-->
                <div class="col-sm-1" style="width: 20px;"><img src="https://www.officemd.net/officemd/IMAGES/document2.gif" alt="document image"></div>
                <div class="col-sm-11">{{ props.item.documentFileName }}</div>        
            </div>
            <div class="row RowDetail">
                <div class="col-sm-5">
                    Created: {{ DateUtils.toDisplayDateString(props.item.dateCreated, UIEnums.DateDisplayFormat.NumericDate) }} {{ DateUtils.prettyTime(props.item.dateCreated) }} 
                    <span v-if="props.item.externalId">by {{ props.item.externalId }}</span>
                </div>
                <div class="col-sm-4">
                    {{ props.item.documentComment }}
                </div>
                <div class="col-sm-2">
                    #{{ props.item.documentId }}
                </div>
            </div>
            <div class="row pt-2 RowDetail">
                <div v-if="props.item.identifierId" class="col-sm-4">
                    {{ props.item.patientFullName }} ({{ props.item.identifierId }})<br>
                    DOB: {{ props.item.patientDob }},  Gender: {{ props.item.patientGender }}
                    <span class="RowDetailWarning" v-if="props.item.isMarkedForDeletion"><br>This document was marked for deletion on {{ DateUtils.toDisplayDateString(props.item.dateMarkedForDeletion, UIEnums.DateDisplayFormat.NumericDate) }} </span>
                </div>
                <div v-if="!props.item.identifierId" class="col-sm-4 RowDetailWarning">
                    <!-- No patient linked to eDocument -->
                </div>
                <div class="col-sm-5"> 
                    <!-- TODO: will there even be reviewer info on these unsolicited? -->                    
                </div>
                <div class="col-sm-2 ">
                    File Size: <PrettyFileSize :bytes="props.item.fileSizeInBytes"></PrettyFileSize> 
                </div>    
                <div class="col-sm-1">
                    <input v-if="!props.item.isMarkedForDeletion" class="me-1" ref="chkDelete" id="chkDelete" :value="props.item.documentId" type="checkbox" title="Check to mark this document for deletion">
                </div>            
            </div>
        </div>
    </SectionPanel>
</template>